import { Injectable, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ModalService {
  // Default
  defaultContent: ElementRef;

  // Subjects
  private status = new BehaviorSubject<boolean>(true);
  private content = new BehaviorSubject<any>(this.defaultContent);

  // Observable
  public currentState = this.status.asObservable();
  public modalRef = this.content.asObservable();

  createModal(state) {
    this.status.next(state);
  }

  setContent(modalRef) {
    this.content.next(modalRef);
  }


}



// WEBPACK FOOTER //
// ./src/app/_common/modal/modal-service.ts